/**
 * cart.js — новая модульная система корзины на Shopify AJAX API
 * Управляет добавлением, удалением, изменением количества и обновлением UI
 */

document.addEventListener("DOMContentLoaded", () => {
  /** Обработчик формы добавления в корзину */
  const productForms = document.querySelectorAll('form[action*="/cart/add"]');

  productForms.forEach((form) => {
    form.addEventListener(
      "submit",
      async (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();

        const button = form.querySelector(".product-page__form-button");

        // Проверяем, не заблокирована ли уже кнопка
        if (button && button.disabled) return;

        // Показываем загрузку
        if (button) {
          button.disabled = true;
          button.style.opacity = "0.6";
        }

        const formData = new FormData(form);

        try {
          await window.CartAPI.addToCart(formData);
        } catch (error) {
          console.error("Ошибка добавления товара:", error);
          alert("Не удалось добавить товар в корзину");
        } finally {
          // Возвращаем кнопку в исходное состояние
          if (button) {
            button.disabled = false;
            button.style.opacity = "1";
          }
        }
      },
      { capture: true }
    );
  });

  /** Обновление пустого состояния */
  function updateEmptyState(cart) {
    const hasItems = cart.item_count > 0;
    const cartItemsWrap = document.querySelector(".cart__items-wrap");
    const cartPopupBot = document.querySelector(".cart-popup__bot");
    const cartPopupEmpty = document.querySelector(".cart-popup__empty");
    
    if (cartItemsWrap) cartItemsWrap.style.display = hasItems ? "flex" : "none";
    if (cartPopupBot) cartPopupBot.style.display = hasItems ? "flex" : "none";
    if (cartPopupEmpty) cartPopupEmpty.style.display = hasItems ? "none" : "flex";
  }

  /** Обновление корзины через Cart API */
  async function refreshCartSections() {
    // Получаем данные корзины
    const cart = await fetch("/cart.js").then((r) => r.json());

    // Обновляем счетчик в header
    document.querySelectorAll(".cart-count-num").forEach((el) => {
      el.textContent = cart.item_count;
    });

    // Обновляем список товаров в обычной корзине
    const cartList = document.querySelector(".cart__items-list");
    if (cartList) {
      cartList.innerHTML = cart.items
        .map((item) => {
          // Проверяем, можно ли добавить еще
          const canIncrease =
            item.quantity < item.inventory_quantity ||
            !item.inventory_management;

          return `
          <div class="cart__item" data-key="${item.key}">
            <div class="cart__img-wrap">
              <img class="cart__img" src="${item.image}" alt="${
            item.product_title
          }" width="392" height="532">
            </div>
            <div class="cart__item-info">
              <div class="cart__item-sec-1">
                <span class="p-semibold">${item.product_title}</span>
                <span class="p-normal">${
                  typeof Shopify !== "undefined" && Shopify.formatMoney
                    ? Shopify.formatMoney(item.final_price)
                    : "$" + (item.final_price / 100).toFixed(2)
                }</span>
              </div>
              <div class="cart__item-sec-2">
                <div class="cart__item-remove">
                  <span class="btn-link">Remove</span>
                </div>
              </div>
              <div class="cart__item-sec-3">
                ${
                  item.variant_options && item.variant_options[1]
                    ? `
                  <div class="cart__item-size">
                    <span class="p-normal">Size: <span class="p-semibold">${item.variant_options[1]}</span></span>
                  </div>
                `
                    : ""
                }
                ${
                  item.variant_options && item.variant_options[0]
                    ? `
                  <div class="cart__item-color">
                    <span class="p-normal">Color: <span class="p-semibold">${item.variant_options[0]}</span></span>
                  </div>
                `
                    : ""
                }
              </div>
              <div class="cart__item-sec-4">
                <div class="cart__item-quantity p-semibold">
                  <span class="cart__item-quantity-minus">-</span>
                  <span class="cart__item-quantity-num">${item.quantity}</span>
                  <span class="cart__item-quantity-plus" style="opacity: ${
                    canIncrease ? "1" : "0.3"
                  }; cursor: ${
            canIncrease ? "pointer" : "not-allowed"
          };" data-can-increase="${canIncrease}">+</span>
                </div>
              </div>
            </div>
          </div>
        `;
        })
        .join("");
    }

    // Обновляем subtotal
    const subtotalEl = document.querySelector(
      ".cart-popup__bot-info-line .p-semibold:last-child"
    );
    if (subtotalEl) {
      if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
        subtotalEl.textContent = Shopify.formatMoney(cart.total_price);
      } else {
        const symbols = {
          USD: "$",
          EUR: "€",
          RUB: "₽",
          GBP: "£",
          JPY: "¥",
          CNY: "¥",
          CAD: "$",
          AUD: "$",
          CHF: "₣",
          SEK: "kr",
          NOK: "kr",
          DKK: "kr",
          PLN: "zł",
          CZK: "Kč",
          HUF: "Ft",
          TRY: "₺",
          UAH: "₴",
          KZT: "₸",
        };
        const symbol = symbols[cart.currency] || "$";
        subtotalEl.textContent = symbol + (cart.total_price / 100).toFixed(2);
      }
    }

    // Обновляем пустой стейт
    updateEmptyState(cart);
    
    // Обновляем статус "Already in cart" в gear popup
    updateGearPopupCartStatus(cart);
  }

  /** Обновление статуса товаров в gear popup */
  function updateGearPopupCartStatus(cart) {
    const gearItems = document.querySelectorAll('.gear__items-list .cart__item');
    
    gearItems.forEach(gearItem => {
      const variantId = gearItem.dataset.variantId;
      const addBtn = gearItem.querySelector('.cart__item-add-active');
      const addedBtn = gearItem.querySelector('.cart__item-added');
      
      if (!addBtn || !addedBtn) return;
      
      // Проверяем есть ли товар в корзине
      const inCart = cart.items.some(item => item.variant_id == variantId);
      
      if (inCart) {
        addBtn.classList.add('hidden');
        addedBtn.classList.remove('hidden');
      } else {
        addBtn.classList.remove('hidden');
        addedBtn.classList.add('hidden');
      }
    });
  }

  /** Добавить товар */
  async function addToCart(formData) {
    const res = await fetch("/cart/add.js?t=" + Date.now(), {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
    });

    if (!res.ok) throw new Error("Ошибка добавления в корзину");
    await refreshCartSections();
    if (window.openCartPopup) window.openCartPopup();
  }

  /** Изменить количество */
  async function updateQuantity(key, quantity) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    await refreshCartSections();
  }

  /** Удалить товар */
  async function removeItem(key) {
    await updateQuantity(key, 0);
  }

  /** Слушатели событий */
  document.body.addEventListener("click", (e) => {
    if (e.target.closest(".cart__item-remove")) {
      const key = e.target.closest(".cart__item").dataset.key;
      removeItem(key);
    }

    if (e.target.classList.contains("cart__item-quantity-minus")) {
      const item = e.target.closest(".cart__item");
      const key = item.dataset.key;
      const qty = parseInt(
        item.querySelector(".cart__item-quantity-num").textContent,
        10
      );
      if (qty > 1) updateQuantity(key, qty - 1);
    }

    if (e.target.classList.contains("cart__item-quantity-plus")) {
      const plusBtn = e.target;
      const canIncrease = plusBtn.dataset.canIncrease === "true";

      if (!canIncrease) return; // Блокируем клик если нельзя увеличить

      const item = e.target.closest(".cart__item");
      const key = item.dataset.key;
      const qty = parseInt(
        item.querySelector(".cart__item-quantity-num").textContent,
        10
      );
      updateQuantity(key, qty + 1);
    }
  });

  /** Инициализация */
  fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => updateEmptyState(cart));

  refreshCartSections();

  window.CartAPI = {
    addToCart,
    updateQuantity,
    removeItem,
    refreshCartSections,
  };
});
